import TableTemplate from "../TableTemplate/tableTemplate";
import { IApplyOptionsCommonSearchParam } from "../../Interfaces/applyOption";
import { CommonTableUI } from "../TableTemplate/common";
import { getPortfolioBuyingPosition } from "../../Requests/applyOption";

interface IProps {
  searchParams: IApplyOptionsCommonSearchParam;
  refreshFlag?: boolean;
}

const AccountOptionsTable = ({ searchParams, refreshFlag }: IProps) => {
  return (
    <TableTemplate<IApplyOptionsCommonSearchParam, any>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[500px] overflow-auto"
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getPortfolioBuyingPosition}
      searchParameters={searchParams}
      pagesize={200}
      withSort
    />
  );
};

export default AccountOptionsTable;
